module.exports = __webpack_public_path__ + "img/bim (12).e05bc21b.png";